const logger = (() => {


    const LoggerEnabled = () => {
        if (process.browser) {
            const search = global?.window?.location?.search;
            const enabled = search && new URLSearchParams(search).get('debug') === 'true';
            global.areLogsEnabled = enabled || false;
            return global.areLogsEnabled;
        }
        return false;
    }
    const isDevlopment = process.env.NODE_ENV !== 'production';

    const print = (type, ...messages) => {
        // console.log("vishnu sharma here for type", type)

        // if (typeof global.areLogsEnabled === 'undefined') {
        //     LoggerEnabled();
        // }
        if (isDevlopment) {
            switch (type) {
                case 'info':
                    console.info('Logger:', ...messages);
                    break;
                case 'warn':
                    console.warn('Logger:', ...messages);
                    break;
                case 'error':
                    console.error('Logger:', ...messages);
                    break;
                case 'trace':
                    console.trace('Logger:', ...messages);
                    break;
                case 'debug':
                default:
                    console.log('Logger:', ...messages);
            }
        }
    };

    return {
        debug: print.bind(null, 'debug'),
        info: print.bind(null, 'info'),
        warn: print.bind(null, 'warn'),
        error: print.bind(null, 'error'),
        trace: print.bind(null, 'trace'),
    };
})();

export default logger;